import React, { useEffect, useState } from "react";
import { X, Copy, Trash2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const fmtD = (v) => (v ? String(v).slice(0, 10).split("-").reverse().join(".") : "-");

export default function DuplicateScanModal({ onClose, onChanged, canDelete }) {
  const [data, setData] = useState(null);
  const load = () => api.get("/personnel/duplicates").then((r) => setData(r.data)).catch(() => setData({ groups: [], count: 0 }));
  useEffect(() => { load(); }, []);

  const remove = async (rec) => {
    if (!window.confirm(`"${rec.ad_soyad}" (TC ${rec.sicil_no}, eklenme ${fmtD(rec.created_at)}) kaydı silinecek. Onaylıyor musunuz?`)) return;
    try {
      await api.delete(`/personnel/${rec.id}`);
      toast.success("Kayıt silindi");
      load();
      onChanged?.();
    } catch (e) {
      toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Silinemedi");
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" onClick={onClose} data-testid="duplicate-scan-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
          <Copy size={16} className="text-amber-600" />
          <h3 className="font-bold text-slate-900">Mükerrer Personel Taraması</h3>
          {data && <span className="text-xs text-slate-500" data-testid="duplicate-scan-count">· {data.count} grup</span>}
          <button onClick={onClose} className="ml-auto w-8 h-8 grid place-items-center rounded-lg hover:bg-slate-100" data-testid="duplicate-scan-close"><X size={16} /></button>
        </div>
        <div className="p-5 overflow-y-auto space-y-3">
          <p className="text-xs text-slate-500">Aynı TC kimlik no ve aynı ad soyada sahip kayıtlar gruplanır. En eski kayıt üstte gösterilir.</p>
          {data === null && <div className="text-sm text-slate-400">Taranıyor...</div>}
          {data && data.count === 0 && (
            <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-3 text-sm text-emerald-800" data-testid="duplicate-scan-empty">
              <CheckCircle2 size={16} /> Mükerrer personel kaydı bulunamadı.
            </div>
          )}
          {data?.groups.map((g, gi) => (
            <div key={`${g.sicil_no}-${gi}`} className="border border-amber-200 rounded-lg overflow-hidden" data-testid={`duplicate-group-${gi}`}>
              <div className="bg-amber-50 px-3 py-2 text-xs font-bold text-amber-900">
                {g.ad_soyad} · TC {g.sicil_no} · {g.records.length} kayıt
              </div>
              <table className="w-full text-xs">
                <tbody className="divide-y divide-slate-100">
                  {g.records.map((r, ri) => (
                    <tr key={r.id} data-testid={`duplicate-record-${r.id}`}>
                      <td className="px-3 py-2 font-semibold text-slate-900">{r.ad_soyad}{ri === 0 && <span className="ml-1.5 text-[10px] font-semibold text-emerald-700">en eski</span>}</td>
                      <td className="px-3 py-2 text-slate-600">{r.pozisyon || "-"}</td>
                      <td className="px-3 py-2 text-slate-600">Başlama: {fmtD(r.ise_baslama_tarihi)}</td>
                      <td className="px-3 py-2 text-slate-500">Eklenme: {fmtD(r.created_at)}</td>
                      <td className="px-3 py-2">
                        <span className={`px-1.5 py-0.5 rounded font-semibold ${r.aktif === false ? "bg-slate-100 text-slate-500" : "bg-emerald-50 text-emerald-700"}`}>{r.aktif === false ? "Pasif" : "Aktif"}</span>
                      </td>
                      <td className="px-3 py-2 text-right">
                        {canDelete && (
                          <button onClick={() => remove(r)} title="Bu kaydı sil" data-testid={`duplicate-delete-${r.id}`}
                            className="p-1.5 bg-rose-50 hover:bg-rose-100 text-rose-700 rounded transition-colors"><Trash2 size={13} /></button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
